import { useContext } from "react";
import { TransferPosition } from "src/services/link/commands/NetTypes";
import { useTransferPositionsRequest } from "src/services/link/commands/transfers";

import ThemeContext from "../../../context";
import Context from "../../context";
import useGetPositionsSelected from "../hooks/useGetPositionsSelected";

// ----------------------------------------------------------------------

export const useTransferPositions = () => {
	const { state } = useContext(Context);
	const { state: themeState, actions } = useContext(ThemeContext);
	const { positionsSelected } = useGetPositionsSelected();

	const { mutate, isPending } = useTransferPositionsRequest(
		themeState.authToken,
		state.connectionToken
	);

	const onSuccess = () => {
		actions.setStep(6);
	};

	const onError = () => {};

	const onTransferPositions = () => {
		const positions: TransferPosition[] = positionsSelected.map((position) => ({
			positionId: position.positionId,
			titles: position.titles,
			amount: position.amount
		}));

		mutate(positions, { onSuccess, onError });
	};

	return { onTransferPositions, isLoading: isPending };
};

export default useTransferPositions;
